import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ReferenceDataLabels } from '../../constants/reference-data-labels';
import { ReferenceDataOptionLists } from '../../constants/reference-data-option-lists';
import { CaseRequestDto } from '../../models/dto/case-overview/case-request-dto.model';
import { ReferenceDataConstants } from '../../constants/reference-data-constants';
import { ReferenceDataService } from '../../services/reference-data.service';
import { ReferenceDataCategoriesConstants } from '../../constants/reference-data-categories';
import { ReferenceDataSwitchCaseStatus } from '../../constants/reference-data-switch-case-status';

@Component({
  selector: 'boi-overview-illustration-status',
  templateUrl: './overview-illustration-status.component.html'
})
export class OverviewIllustrationStatusComponent {
  @Input() public caseRequest: CaseRequestDto;
  @Input() public interfaceTypeCode: string;
  @Input() public caseIdAsHash: string;
  @Input() public areIllustrationsReady: boolean;
  @Output() public readonly productTransfer = new EventEmitter<CaseRequestDto>();

  public referenceDataLabels = ReferenceDataLabels;
  public referenceDataOptionLists = ReferenceDataOptionLists;
  public referenceDataConstants = ReferenceDataConstants;
  public referenceDataSwitchCaseStatus = ReferenceDataSwitchCaseStatus;
  public showImportantIllustrationInfo: boolean;

  public illustrationPendingStatuses: string[] = [
    this.referenceDataSwitchCaseStatus.IllustrationRequested,
    this.referenceDataSwitchCaseStatus.IllustrationDownloadPending
  ];

  public illustrationManualStatuses: string[] = [
    this.referenceDataSwitchCaseStatus.IllustrationManualProcessing,
    this.referenceDataSwitchCaseStatus.IllustrationDownloadFailed
  ];

  public illustrationReadyStatuses: string[] = [this.referenceDataSwitchCaseStatus.IllustrationIssued];

  constructor(private readonly referenceDataService: ReferenceDataService) {
    this.showImportantIllustrationInfo =
      this.referenceDataService.getConfigurationValue(
        ReferenceDataCategoriesConstants.CLIENT_ENVIRONMENT_CATEGORY,
        ReferenceDataConstants.ShowImportantMessageIllustrationOverview
      ) === ReferenceDataOptionLists.AnswerTypeYes
        ? true
        : false;
  }

  public goToProductTransfer(): void {
    if (this.caseRequest.IsActiveProduct && this.areIllustrationsReady) {
      this.productTransfer.emit(this.caseRequest);
    }
  }
}
